import React, { useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { connect } from "react-redux";

const App = ({ startNodeId, props }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://api.healthsetgo.com/api/v2/organization/overview",
          {
            headers: {
              "X-Select": `{"in_event_track_id": ${startNodeId}}`,
              Authorization:
                "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhZGRyZXNzIjpudWxsLCJyb2xlIjpbeyJyb2xlX3R5cGVfaWQiOjE2LCJjcmVhdGVkX3RpbWUiOiIyMDE5LTAzLTI4VDA4OjQ3OjUyLjM4MDQ4IiwibW9kaWZpZWRfdGltZSI6IjIwMTktMDMtMjhUMDg6NDc6NTIuMzgwNDgiLCJ1c2VyX2lkIjozMjg5ODIsInJvbGVfZGVzYyI6IkNFTyhTdXBlciBBZG1pbikiLCJpZCI6MzI4OTE1LCJyb2xlX2FjdGl2ZSI6MX1dLCJwcm9maWxlIjpudWxsLCJjdXN0b20iOlt7ImNyZWF0ZWRfdGltZSI6IjIwMTktMDMtMjhUMDg6NDc6NTMuNzU2MTE4IiwibW9kaWZpZWRfdGltZSI6IjIwMTktMDMtMjhUMDg6NDc6NTMuNzU2MTE4Iiwib2xkX2pzb24iOnt9LCJ1c2VyX2lkIjozMjg5ODIsImpzb25fdmFsdWUiOnsiem9uZUlkcyI6InsxLDIsMyw0fSJ9LCJmaWVsZF9hY3RpdmUiOjEsImlkIjozMjg4NDB9XSwiZXh0X3Byb3ZpZGVyX2lkIjpudWxsLCJ1dWlkIjoiSFNHLTMyODk4MSIsInRva2VuIjpudWxsLCJ1c2VyX2FjdGl2ZSI6MSwicGhvbmUiOm51bGwsIm9yZ2FuaXphdGlvbiI6bnVsbCwiaWQiOjMyODk4MiwiaWF0IjoxNjAyNDk0Mjc1LCJlbWFpbCI6bnVsbCwidXNlcm5hbWUiOiJvcHNAaGVhbHRoc2V0Z28uY29tIiwic3RhdHVzIjoyMDB9.zbywt1QgxmWvbsI8sjVolOWwmxRttgWt5mfgWXeUdAE=",
            },
          }
        );
        const jsonData = await response.json();

        const overviewData = JSON.parse(
          jsonData.results[0].organizationoverview
        );
        const activityNames = {
          3: "ENT",
          4: "Eye",
          5: "Physical",
          6: "Dental",
        };

        const formattedData = overviewData.map((item) => ({
          name: activityNames[item.activity_id],
          NEEDSATTENTION: item.students,
          NORMAL: item.total_students - item.students,
        }));

        setData(formattedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [startNodeId]);

  const legendFormatter = (value) => {
    return value === "NEEDSATTENTION" ? "NEEDS ATTENTION" : value;
  };

  return (
    <ResponsiveContainer height={300}>
      <BarChart
        layout="horizontal"
        style={{
          maxHeight: "70vh",
          aspectRatio: 1.618,
        }}
        responsive
        data={data}
        height={"100%"}
        width={"100%"}
        margin={{
          top: 20,
          right: 30,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend
          formatter={legendFormatter}
          layout={"horizontal"}
          align={"center"}
        />
        <Bar
          isAnimationActive={true}
          style={{ fontFamily: "Montserrat" }}
          dataKey="NORMAL"
          stackId="a"
          fill="#64d78b"
          // fill="#4880FF"
          barSize={30}
        />
        <Bar
          isAnimationActive={true}
          dataKey="NEEDSATTENTION"
          stackId="a"
          fill="#eda44e"
          // fill="#E0E9FF"
          barSize={30}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

const mapStateToProps = (state) => {
  const currentProgram = state.organization.currentProgram;
  const startNodeMap = state.organization.startNodeMap;
  const startNodeId =
    currentProgram && currentProgram.billing
      ? startNodeMap[currentProgram.billing.id]?.id
      : null;

  return {
    startNodeId,
  };
};

export default connect(mapStateToProps)(App);
